module.exports = __webpack_public_path__ + "img/z (35).3b757247.png";